import { render, staticRenderFns } from "./ehc-file-input.vue?vue&type=template&id=2938012a&scoped=true"
import script from "./ehc-file-input.vue?vue&type=script&lang=js"
export * from "./ehc-file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938012a",
  null
  
)

export default component.exports